/* eslint-disable max-len */

import angular from 'angular';
import * as R from 'ramda';

export default function EditRiskDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  assignControlDialog,
  controlDataService,
  editRiskDialog,
  riskSharedModelDataService,
  editControlDialog,
  controlSharedModelService
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditRiskSubmit = _handleEditRiskSubmit;
  // vm.handleAssignControlDialog = _handleAssignControlDialog;
  vm.handleRiskTypeChange = _handleRiskTypeChange;
  vm.handleAddControlDialog = _handleAddControlDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.firstLoad = true;
    vm.newRisk = angular.copy(vm.risk);
    setSelectedAsset();
    loaderService.showViewLoader = false;
  }

  function _initEventListeners() {
    $scope.$on('refreshRiskControls', (event, opt) => {
      _getAssignedControl(opt.risk);
    });
  }

  function _handleCloseDialogClick() {
    // $rootScope.$broadcast('refreshRisks');
    ssDialogService.hide(ssDialogService.dialogs.riskAdmin.editRiskDialog);
  }

  function _handleEditRiskSubmit() {
    if ($scope.editRiskForm.$valid) {
      _saveRisk()
        .then(() => {
          if (vm.saveType === 'saveAndAddAnother') {
            _resetViewModel();
          } else {
            _closeDialog();

            if (vm.asset) {
              $rootScope.$broadcast('refreshAssetRisks', { asset: vm.asset });
            } else if (vm.riskType || vm.isRiskMain === true) {
              $rootScope.$broadcast('refreshRiskType', { riskType: vm.riskType || vm.newRisk.customerRiskType });
            } else {
              $rootScope.$broadcast('refreshRisks');
            }
            if (vm.updateCallBack) {
              vm.updateCallBack();
            }

            $rootScope.$broadcast('refreshAssetTypes');
            loaderService.showViewLoader = false;
          }
        });
    }
  }

  function _handleAddControlDialog($event) {
    vm.isAddControl = true;
    $scope.editRiskForm.$submitted = true;
    if ($scope.editRiskForm.$valid) {
      vm.isAddControl = false;
      $scope.editRiskForm.$submitted = false;
      _saveRisk().then(() => {
        const control = {
          customerControlId: 0,
          customerRiskControl: {}
        };
        control.customerRiskControl.customerRiskId = vm.newRisk.customerRiskId;
        $q.all([
          controlSharedModelService.initControlAdmin(),
          controlDataService.getControlById(control.customerControlId),
          controlDataService.getControlTypeDefaults(),
        ])
          .then((response) => {
            control.controlPreventiveEffectivenessId = response[2].data.controlPreventiveEffectiveness.controlPreventiveEffectivenessId;
            control.controlDetectiveEffectivenessId = response[2].data.controlDetectiveEffectiveness.controlDetectiveEffectivenessId;
            control.controlCorrectiveEffectivenessId = response[2].data.controlCorrectiveEffectiveness.controlCorrectiveEffectivenessId;
            control.controlAdministrativeNatureId = response[2].data.controlAdministrativeNature.controlAdministrativeNatureId;
            control.controlTechnicalNatureId = response[2].data.controlTechnicalNature.controlTechnicalNatureId;
            control.controlPhysicalNatureId = response[2].data.controlPhysicalNature.controlPhysicalNatureId;
            control.controlPrimaryControlTypeId = response[2].data.controlPrimaryControlType.controlPrimaryControlTypeId;
            control.controlCompensatingControlTypeId = response[2].data.controlCompensatingControlType.controlCompensatingControlTypeId;
            control.controlReviewSchedule = response[2].data.controlReviewSchedule;
            control.controlReviewType = response[2].data.controlReviewType;
            control.controlResult = response[2].data.controlResult;
            ssDialogService.dialogs.controlAdmin.editControlDialog = ssDialogService.alert(
              editControlDialog.getOptions($event, {
                control,
                controlTypes: response[1].data.CustomerControlTypes,
                risks: response[1].data.CustomerRiskData,
                addCallback: null,
                risk: vm.risk,
                controlResults: controlSharedModelService.ControlResults,
                controlPreventiveEffectivenesses: controlSharedModelService.ControlPreventiveEffectivenesses,
                controlDetectiveEffectivenesses: controlSharedModelService.ControlDetectiveEffectivenesses,
                controlCorrectiveEffectivenesses: controlSharedModelService.ControlCorrectiveEffectivenesses,
                controlAdministrativeNatures: controlSharedModelService.ControlAdministrativeNatures,
                controlPhysicalNatures: controlSharedModelService.ControlPhysicalNatures,
                controlTechnicalNatures: controlSharedModelService.ControlTechnicalNatures,
                controlPrimaryControlTypes: controlSharedModelService.ControlPrimaryControlTypes,
                controlCompensatingControlTypes: controlSharedModelService.ControlCompensatingControlTypes,
                controlReviewSchedules: controlSharedModelService.ControlReviewSchedules,
                controlReviewTypes: controlSharedModelService.ControlReviewTypes,
              })
            );
            ssDialogService.show(ssDialogService.dialogs.controlAdmin.editControlDialog);
          });
      });
    }
    return false;
  }

  // function _handleAssignControlDialog($event) {
  //   if ($scope.editRiskForm.$valid) {
  //     const promises = [
  //       controlDataService.getControls(),
  //       _saveRisk(),
  //     ];
  //     return $q.all(promises).then((results) => {
  //       const _controls = results[0].data.result;
  //       ssDialogService.dialogs.riskAdmin.assignControlDialog = ssDialogService.alert(
  //         assignControlDialog.getOptions($event, {
  //           risk: vm.risk,
  //           controls: _controls
  //         })
  //       );
  //       ssDialogService.show(ssDialogService.dialogs.riskAdmin.assignControlDialog);
  //     });
  //   }
  //   return false;
  // }

  function _saveRisk() {
    const isNew = vm.newRisk.customerRiskId <= 0;
    if (!isNew && angular.equals(vm.risk, vm.newRisk)) {
      return Promise.resolve();
    }
    loaderService.showViewLoader = true;
    if (vm.selectedAsset) {
      const _selectedAsset = {};
      vm.newRisk.customerRisks = [];
      _selectedAsset.customerAssetRiskId = 0;
      _selectedAsset.customerRiskId = vm.newRisk.customerRiskId;
      _selectedAsset.customerAssetId = vm.selectedAsset.Id;
      vm.newRisk.customerRisks.push(_selectedAsset);
      vm.newRisk.customerAsset = _selectedAsset;
    }
    return riskDataService.saveRisk(vm.newRisk).then((response) => {
      if (response.status === 200 || response.status === 201) {
        alerts.success('The risk has been saved successfully.');
        if (isNew === true) {
          vm.newRisk.customerRiskId = response.data.customerRiskId;
        }
        vm.risk = angular.copy(vm.newRisk);
      } else {
        alerts.error('Error occurred while saving the risk.');
      }
      loaderService.showViewLoader = false;
    });
  }

  function _getAssignedControl(risk) {
    if (risk.control) {
      if (risk.action === 'delete') {
        angular.forEach(vm.newRisk.customerControls, (existingControl, index) => {
          if (existingControl.customerControlId === risk.control.customerControlId) {
            vm.newRisk.customerControls.splice(index, 1);
          }
        });
      } else if (risk.action === 'add') {
        vm.newRisk.customerControls = vm.newRisk.customerControls || [];
        vm.newRisk.customerControls.push(risk.control);
        vm.newRisk.customerControls = R.sortBy(
          R.prop('name'),
          vm.newRisk.customerControls
        );
      } else if (risk.action === 'update') {
        const existingControl = R.find(
          R.propEq('customerControlId', risk.control.customerControlId),
          vm.newRisk.customerControls
        );
        angular.extend(existingControl, risk.control);
      }
    }
    vm.risk = angular.copy(vm.newRisk);
    loaderService.showViewLoader = false;
  }


  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.riskAdmin.editRiskDialog);
  }

  function _handleRiskTypeChange() {
    if (vm.newRisk.customerRiskId > 0 && vm.firstLoad === true) {
      vm.firstLoad = false;
      return;
    }
    if (vm.newRisk.customerRiskType) {
      vm.newRisk.customerRiskTypeId = vm.newRisk.customerRiskType.customerRiskTypeId;
      vm.newRisk.riskOnsetId = vm.newRisk.customerRiskType.riskOnsetId;
      vm.newRisk.riskForewarningId = vm.newRisk.customerRiskType.riskForewarningId;
      vm.newRisk.riskDurationId = vm.newRisk.customerRiskType.riskDurationId;
      vm.newRisk.riskDataConfidentialityId = vm.newRisk.customerRiskType.riskDataConfidentialityId;
      vm.newRisk.riskDataIntegrityId = vm.newRisk.customerRiskType.riskDataIntegrityId;
      vm.newRisk.riskDataAvailabilityId = vm.newRisk.customerRiskType.riskDataAvailabilityId;
      vm.newRisk.riskDirectionId = vm.newRisk.customerRiskType.riskDirectionId;
      vm.newRisk.riskTrendingId = vm.newRisk.customerRiskType.riskTrendingId;
      vm.newRisk.riskAssessmentFrequencyId = vm.newRisk.customerRiskType.riskAssessmentFrequencyId;
      vm.newRisk.riskProbabilityId = vm.newRisk.customerRiskType.riskProbabilityId;
      vm.newRisk.riskClassificationId = vm.newRisk.customerRiskType.riskClassificationId;
      vm.newRisk.threatDirectionMultiplier = vm.newRisk.customerRiskType.threatDirectionMultiplier;
    }
  }

  function setSelectedAsset() {
    console.log('vm.newRisk.customerAsset', vm.newRisk.customerAsset);
    console.log('vm.preselectedAssetId', vm.preselectedAssetId);
    vm.selectedAsset = {};
    if (vm.newRisk.customerAsset) {
      vm.selectedAsset.Id = vm.newRisk.customerAsset.customerAssetId;
    } else if (vm.preselectedAssetId && vm.preselectedAssetId > 0) {
      const find = vm.assets.find(asset => asset.Id === vm.preselectedAssetId);
      if (find) {
        vm.selectedAsset.Id = vm.preselectedAssetId;
      }
    }
    console.log('vm.selectedAsset', vm.selectedAsset);
  }

  function _resetViewModel() {
    const _risk = { customerRiskId: 0 };
    loaderService.showViewLoader = true;
    _risk.customerRiskType = null;
    riskDataService.getRiskTypeDefaults().then((response) => {
      _risk.riskOnsetId = response.data.riskOnset.riskOnsetId;
      _risk.riskForewarningId = response.data.riskForewarning.riskForewarningId;
      _risk.riskDurationId = response.data.riskDuration.riskDurationId;
      _risk.riskDataConfidentialityId = response.data.riskDataConfidentiality.riskDataConfidentialityId;
      _risk.riskDataIntegrityId = response.data.riskDataIntegrity.riskDataIntegrityId;
      _risk.riskDataAvailabilityId = response.data.riskDataAvailability.riskDataAvailabilityId;
      _risk.riskDirectionId = response.data.riskDirection.riskDirectionId;
      _risk.riskTrendingId = response.data.riskTrending.riskTrendingId;
      _risk.riskAssessmentFrequencyId = response.data.riskAssessmentFrequency.riskAssessmentFrequencyId;
      _risk.riskProbabilityId = response.data.riskProbability.riskProbabilityId;
      _risk.riskClassificationId = response.data.riskClassification.riskClassificationId;
      $timeout(
        () => {
          vm.risk = angular.copy(_risk);
          vm.newRisk = angular.copy(_risk);
          loaderService.showViewLoader = false;
          $scope.editRiskForm.$setPristine();
          $scope.editRiskForm.$setUntouched();
          $timeout(
            () => {
              angular.element('#dialogContent_editRiskDialog')[0].scrollTop = 0;
            }, 0
          );
        },
        100
      );
    });
  }
}

EditRiskDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'assignControlDialog',
  'controlDataService',
  'editRiskDialog',
  'riskSharedModelService',
  'editControlDialog',
  'controlSharedModelService',
];
